import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appQuizFixedTime]'
})
export class QuizFixedTimeDirective {

  d1 = <any>$(this.el.nativeElement);
  constructor(
    private el: ElementRef
  ) {
    setTimeout(() => {
      this.check();
    }, 1000);
  }

  check() {
    (this.d1).stickyTableHeaders({
      // fixedOffset: 55,
      scrollableArea: $(".container-fluid")
    });

    $('.table-responsive').scroll(() => {
      let scroll = $('.table-responsive').scrollLeft();
      var check = $('.sidebar-hidden');
      if (check.length > 0) {
        scroll = scroll - 42;
      } else {
        scroll = scroll - 240.994;
      }
      $('.tableFloatingHeaderOriginal').css({ left: -scroll! });
    });
  }



  @HostListener('window:scroll') onResize() {
   
  }
}



// WEBPACK FOOTER //
// /app/src/app/directives/quiz-fixed-time/quiz-fixed-time.directive.ts